import { cn } from "@app/lib/utils";
import { InputLabel } from "@design-system/components/Form/InputLabel";
import {
  InputRule,
  maxLengthRule,
  minLengthRule,
  requiredRule,
  useFormControl,
  type FormControlProps,
} from "@mongez/react-form";
import { ErrorInput } from "./ErrorInput";

export type BaseInputProps = FormControlProps & {
  rules?: InputRule[];
  classes?: {
    wrapper?: string;
    input?: string;
  };
};

export function BaseInput({ classes, rules = [], ...props }: BaseInputProps) {
  const {
    changeValue,
    value,
    error,
    type,
    id,
    disabled,
    inputRef,
    otherProps,
  } = useFormControl({
    ...props,
    rules: [requiredRule, minLengthRule, maxLengthRule, ...rules],
  });

  return (
    <div
      className={cn(
        "flex h-[82px] w-full flex-col gap-1",
        props.classes?.wrapper,
      )}
    >
      {props.label && (
        <InputLabel required={props.required}>{props.label}</InputLabel>
      )}
      <input
        value={value}
        onChange={(e) => changeValue(e.target.value)}
        id={id}
        type={type}
        ref={inputRef}
        disabled={disabled}
        className={cn(
          "focus-within:border-dark-900 h-auto w-full rounded-2xl border border-white/40 bg-transparent px-5 py-4 text-white transition-colors placeholder:text-white/40 focus:outline-none focus:ring-0",
          classes?.input,
          error && "border-red-500",
        )}
        {...otherProps}
      />
      <ErrorInput>{error}</ErrorInput>
    </div>
  );
}
